// extracted by mini-css-extract-plugin
module.exports = {"icon-button":"navigation-mobile_icon-button__8pHIu","logo":"navigation-mobile_logo__wPmfi"};